//@flow

import {useEffect} from 'react';

export function useUnMount(cb: Function) {
  useEffect(() => {
    return () => {
      cb();
    };
  }, [cb]);
}
